export const removeHyphen = (digits: string) => digits.replace(/-/g, '');

export const addHyphenPhoneNumber = (digits: string) => {
  if (digits.length > 3 && digits.length <= 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  } else if (digits.length > 7 && digits.length <= 11) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
  }
  return digits;
};
